import { render, staticRenderFns } from "./TipoServicoFaixa03.vue?vue&type=template&id=17c46a32&"
import script from "./TipoServicoFaixa03.vue?vue&type=script&lang=js&"
export * from "./TipoServicoFaixa03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports